import React, { useState, useEffect } from "react";
import styles from "./Login.module.css";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import notify from "../Utilities/notify";
import { useDispatch , useSelector} from "react-redux";
import { login } from "../../redux/Slices/users/thunk";
import Spinner from 'react-bootstrap/Spinner';
import CustumNumberInput from '../Utilities/CustumNumberInput';
import CountrySelect from '../Utilities/CountrySelect'; 

const Login = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const [loading, setLoading] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [selectedCountry, setSelectedCountry] = useState({ code: 'SA', label: 'Saudi Arabia', countryCode: '+966' });
  const dispatch = useDispatch();
  const navigate = useNavigate();

  console.log("selectedCountry",selectedCountry)
  console.log("Selected country in Login:", selectedCountry);

  const handleChange = (e) => {
    setPhoneNumber(e.target.value);
  };

  const handleSubmit = async () => {
    const fullPhoneNumber = selectedCountry 
    ? `${selectedCountry.countryCode.replace('+', '')}${phoneNumber}`
    : `966${phoneNumber}`;    console.log("Phone number submitted:", fullPhoneNumber);

    const data = {
      mobile: fullPhoneNumber
    };

    try {
      setLoading(true);
      let res = await fetch('https://reservation.ladycaresa.com/api/v1/clients/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        }, 
        body: JSON.stringify(data)
      });
      setLoading(false);
      res = await res.json();
      if (res?.cln_key) {
        localStorage.setItem('user', JSON.stringify(res));
        localStorage.setItem("selectedCountry", JSON.stringify(selectedCountry));

        navigate("/otp", { state: { res: res } });
      }
      if (res?.token) {
        localStorage.setItem('token', res?.token);
      }
      if (res?.message) {
        notify(res?.message || "An error occurred", "error");
      }
    } catch (error) {
      setLoading(false);
      console.log("error", error);

    }
  };

  const handleNavigateToSignup = () => {
    navigate("/signup");
  };

  return (
    <div className={styles.loginContainer}>
      <div className={styles.loginContent}>
        <div className={styles.inputContainer}>
          <div className={styles.inputWrapper}>
          <CountrySelect
            value={selectedCountry}
            onChange={setSelectedCountry} // Set selected country
          /> 
                   </div>
          <div className={styles.inputWrapperWithIcon}>
            <CustumNumberInput
              placeholder={t("phoneNumber")}
              className={styles.inputField}
              value={phoneNumber}
              setValue={setPhoneNumber}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  handleSubmit();
                }
              }}
              style={{ direction: currentLanguage === "ar" ? "rtl" : "ltr" }}
            />
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="41" viewBox="0 0 40 41" fill="none" className={styles.inputIcon}>
              <path
                d="M25.8294 5.5H14.9961C12.2347 5.5 9.99609 7.73858 9.99609 10.5V31.3333C9.99609 34.0948 12.2347 36.3333 14.9961 36.3333H25.8294C28.5908 36.3333 30.8294 34.0948 30.8294 31.3333V10.5C30.8294 7.73858 28.5908 5.5 25.8294 5.5Z"
                stroke="#8B8C8C"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M18.7461 30.5H22.0794"
                stroke="#8B8C8C"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>


        <div className={styles.submitContainer}>
          <div className={styles.onSubmit} onClick={handleSubmit} disabled={loading}>
            {loading ? <Spinner /> : t("send")}
          </div>
          <div className={styles.onRegister} onClick={handleNavigateToSignup}>
            {t("signUp")}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
